import {
  getRealtimeHubConnection,
  startRealtimeHubConnection,
} from "@/utils/realtimeHub.js";

/**
 * @deprecated Import generic helpers from "@/calling/realtime/callHubClient.js" or "@/calling".
 * This file remains as the hotel legacy hub adapter.
 */
export {
  createCallHubClient,
  invokeCallHub,
  registerHandler,
} from "@/calling/realtime/callHubClient.js";

const debugCallHub = (...args) => {
  if (import.meta.env?.DEV) {
    console.debug("[call-module]", ...args);
  }
};

export const getCallConnection = ({ mode = "staff", guestSessionId, webContactToken } = {}) => {
  return getRealtimeHubConnection({
    guestSessionId: mode === "guest" ? guestSessionId : undefined,
    webContactToken: mode === "web_visitor" ? webContactToken : undefined,
  });
};

export const startCallConnection = async ({ mode = "staff", guestSessionId, webContactToken } = {}) => {
  debugCallHub("start requested", { mode, guestSessionId: guestSessionId || null, webContactToken: webContactToken || null });
  const connection = await startRealtimeHubConnection({
    guestSessionId: mode === "guest" ? guestSessionId : undefined,
    webContactToken: mode === "web_visitor" ? webContactToken : undefined,
  });
  debugCallHub("connected", { mode, state: connection.state });
  return connection;
};


